module.exports = require('./dist/react-data-grid-addons');


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-data-grid-addons/index.js
 ** module id = 227
 ** module chunks = 0
 **/